import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core'
import { LocalDataService } from 'app/services/local-data.service'
import { environment } from 'environments/environment'

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnChanges {
  @Input() public content: any
  public apiHost = environment.API_HOST
  public lang = this.localDataService.getLocale().language
  public shortLinks = []

  constructor(private localDataService: LocalDataService) {
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (const item of this.content) {
      try {
        const shortLink = item.data.video ? new URL(item.data.video).hostname : '';
        this.shortLinks.push(shortLink)
      } catch {
        return null
      }
    }
  }
}
